import React from 'react';
import { AuthProvider } from './context/AuthContext';
import { DataProvider } from './context/DataContext';
import NavigationInterface from './components/NavigationInterface';

function App() {
  return (
    <AuthProvider>
      <DataProvider>
        <NavigationInterface />
      </DataProvider>
    </AuthProvider>
  );
}

export default App;
